// LOADER
// ------

 function loader(){
	 $('#loader').css({
	   'width' : $(document).width(),
	   'height' : $(document).height()
	 }).delay(500).fadeOut(500);
 }